<div #header class="fixed-top">
  <nk-header *ngIf="!isMobile"></nk-header>
  <nk-mobile-header [backgroundColor]="'brand-color'" *ngIf="isMobile || isSmallMobile"></nk-mobile-header>
  <nk-site-warning-top-banner *ngIf="!isMobile"></nk-site-warning-top-banner>
</div>
<div class="app-body" [ngStyle]="{ 'margin-top': headerHeight + 'px' }">
  <main class="main" *ngIf="layout$ | async as layout" [class.expanded]="layout.expanded">
    <nk-sub-navigation>
      <router-outlet name="header"></router-outlet>
    </nk-sub-navigation>
    <div
      id="main-route"
      class="container"
      style="padding-top: 20px; padding-bottom: 50px"
      [class.container-fluid]="layout.expanded"
      [class.container]="!layout.expanded">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<nk-footer></nk-footer>
